import { render, staticRenderFns } from "./CardReseller.vue?vue&type=template&id=578c394d&scoped=true"
import script from "./CardReseller.vue?vue&type=script&lang=js"
export * from "./CardReseller.vue?vue&type=script&lang=js"
import style0 from "./CardReseller.vue?vue&type=style&index=0&id=578c394d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578c394d",
  null
  
)

export default component.exports